import { AppContext } from "../../App";
import { useContext } from "react";
import { NavLink, Link } from 'react-router-dom';
import { React, useState, useEffect } from "react";


// import Components
import { SlideCardsSoporte } from './slideCardsSoporteComponent/slideCardsSoporte';


//Import CSS
import './cardSoportEmpCompt.css'
import '../home/slideCardsSoporteComponent/slideCardsSoporte'


//Import Swiper React components
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';


export function CarSoportEmpCompt() {

    const { 

        //Iconos Soporte
        IconSoporteLicencias,
        IconSoporHosting,
        IconSoporEmailMark,
        IconSoporFormatting,
        IconArrowNext

    } = useContext(AppContext);


    return(

        <div className="box-card-soporte-empresas">

            <Swiper
                    
                modules={[Navigation, Pagination]}
                spaceBetween={0}       // separación entre slides
                slidesPerView={1}       // cuántos se ven al mismo tiempo
                centeredSlides={true}
                slidesOffsetBefore={120}  // padding al inicio
                slidesOffsetAfter={0}   // padding al final 
                navigation              // flechas de navegación
                pagination={{ clickable: true }} // puntos de paginación
                breakpoints={{

                    0: {
                            spaceBetween: 0,   
                            slidesPerView: 1,   // desde 0px hasta 820px
                            centeredSlides: true,
                            centerInsufficientSlide: true,
                            slidesOffsetBefore: 35,
                            slidesOffsetAfter: 0,
                        },


                    420: {
                            slidesPerView: 1,   // desde 0px hasta 820px
                            centeredSlides: true,
                            centerInsufficientSlide: true,
                            slidesOffsetBefore: 60,
                            slidesOffsetAfter: 0,
                        },


                    480: {
                            slidesPerView: 1,   // desde 0px hasta 820px
                            centeredSlides: true,
                            centerInsufficientSlide: true,
                            slidesOffsetBefore: 90,
                            slidesOffsetAfter: 0,
                        },


                    680: {
                            slidesPerView: 1,   // desde 0px hasta 820px
                            centeredSlides: true,
                            centerInsufficientSlide: true,
                            slidesOffsetBefore: 120,
                            slidesOffsetAfter: 0,
                        }

                }}
                    
                >
                    
                <SwiperSlide> 
                    {/* Card Soporte - 1 */}                    
                    <SlideCardsSoporte 
                        
                        iconSoporte={IconSoporteLicencias}
                        titleSoporte="Software y licencias"
                        textSoporte="Instalación de paquetes de Office, Adobe, Antivirus y más. Trabajamos con licencias originales o alternas."

                        />

                </SwiperSlide>           
                        
                <SwiperSlide> 
                    {/* Card Soporte - 2 */}
                    <SlideCardsSoporte 
                        
                        iconSoporte={IconSoporHosting}
                        titleSoporte="Hosting, Dominio, Email"
                        textSoporte="Venta y configuración de hosting, dominios y cuentas de email corporativo."

                        />

                </SwiperSlide>    


                <SwiperSlide> 

                    {/* Card Soporte - 3 */}
                    <SlideCardsSoporte 
                        
                        iconSoporte={IconSoporEmailMark}
                        titleSoporte="Email Marketing"
                        textSoporte="Diseño y programación de mailing corporativo con base de datos de empresa y negocios."

                        />

                </SwiperSlide>    


                <SwiperSlide> 
                
                    {/* Card Soporte - 4 */}
                    <SlideCardsSoporte 
                        
                        iconSoporte={IconSoporFormatting}
                        titleSoporte="Formatting Windows"
                        textSoporte="Formateamos y reinstalamos Windows de fábrica, limpieza de registros, apps y software malicioso."

                        />

                </SwiperSlide>    


            </Swiper> 

                
        </div>

    );

}